module.exports = __webpack_public_path__ + "static/media/panel_comment_off.71ab3703.svg";